// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".col_text[data-v-e4c4565c]{text-align:center}", ""]);
// Exports
module.exports = exports;
